/**
 * @param {string} tarif - possible values: "basis", "pool", "securo", "securoplus", "securopremium", "mv", "mvmg"
 * @param {boolean} pks - true if user has PKS rights
 * @returns {object} praemien availability
 */
export function getAvailability(tarif, pks) {
  const availabilities = {};
  generateAvailability(availabilities, tarif, pks);
  return availabilities;
}

const productsMain = ["PBVW", "PVW", "PBV", "PBW", "PB", "PV", "PW"];
const productsYolig = ["PBVW", "PVW", "PBV", "PBW", "PB", "PV"];
const productsVerkehr = ["V-VN", "V-Familie", "FzRS", "Fahrer"];
const productsLimitedVerkehr = ["V-VN", "V-Familie"];
const productsMieterverein = ["M"];

const allSbs = ["SB150", "SB300", "SB500"];

const productsStandard = productsMain.concat(productsVerkehr);

function generateAvailability(availabilities, tarif, pks) {
  let products;
  switch (tarif) {
    case 'basis':
    case 'pool':
      generateBaseAvailability(availabilities);
      if (pks) allowSchubladeP(availabilities, ["SB0", "SB150", "SB300"]);
      if (pks) allowSchubladeSB0(availabilities, productsStandard.filter(p => p !== "Fahrer"));
      break;
    case 'mv':
      products = productsStandard.filter(p => p.indexOf("W") < 0).concat(["P"]);
      allowStandard(availabilities, ["SB150"], products);
      break;
    case 'mvmg':
      products = productsStandard.filter(p => p.indexOf("W") < 0).concat(["P"]).concat(productsMieterverein);
      allowStandard(availabilities, ["SB150"], products);
      break;
    case 'comfortplan':
      products = ["PBVW", "PBW", "PVW", "PBV"];
      allowStandard(availabilities, ["SB150", "SB300"], products);
      break;
    case 'securo':
      products = ["PBVW", "PBV"].concat(productsLimitedVerkehr);
      allowStandard(availabilities, ["SB150", "SB300"], products);
      break;
    case 'securopremium':
      products = ["PBVW", "PBV", "PVW"];
      allowStandard(availabilities, ["SB150", "SB300"], products.concat(productsLimitedVerkehr));
      break;
    case 'securoplus':
      // Nach Ablauf der CLARO exklusiv Phase
      //allowStandard(availabilities, ["SB150", "SB300", "SB400", "SB750", "SB1000"], productsMain.concat(productsLimitedVerkehr));
      // Securo SB0 wird von PIA nicht unterstuetzt allowSchubladeSB0(availabilities, ["PBVW", "PBV", "PVW"]);
      allowStandard(availabilities, ["SB150", "SB300"], productsMain.concat(productsLimitedVerkehr));
      break;
    default:
      generateBaseAvailability(availabilities);
  }
  return availabilities;
}

function generateBaseAvailability(availabilities) {

  const productsExpert = productsStandard.concat(["P"]);
  const productsPrestige = productsMain.concat(["P"]);
  allowStandard(availabilities, ["SB150", "SB300"], productsStandard);
  allowExpert(availabilities, allSbs, productsExpert);
  allowPrestige(availabilities, allSbs, productsPrestige);
  allowYolig(availabilities, ["SB150", "SB300", "SB500"], productsYolig);
  allowSsr(availabilities);
  allowZweitwohnung(availabilities);
  allowVermRS(availabilities);
  allowCyber(availabilities);

  allowSus(availabilities);
  return availabilities;
}

//allow Standard for for given "Selbstbeteiligungen" and products
function allowStandard(availabilities, sbs, products) {
  for (let sb of sbs) {
    for (let product of products) {
      availabilities["STD" + sb + product] = true;
    }
  }
}

//allow Expert for for given "Selbstbeteiligungen" and products
function allowExpert(availabilities, sbs, products) {
  for (let sb of sbs) {
    for (let product of products) {
      availabilities["EXP" + sb + product] = true;
    }
  }
}

//allow Prestige for for given "Selbstbeteiligungen" and products
function allowPrestige(availabilities, sbs, products) {
  for (let sb of sbs) {
    for (let product of products) {
      availabilities["PRE" + sb + product] = true;
    }
  }
}

//allow YOLIG for for given "Selbstbeteiligungen" and products
function allowYolig(availabilities, sbs, products) {
  for (let sb of sbs) {
    for (let product of products) {
      availabilities["YOLIG" + sb + product] = true;
    }
  }
}

function allowSsr(availabilities) {
  for (let productLine of ["EXP", "PRE", "YOLIG"]) {
    for (let sb of allSbs) {
      availabilities[productLine + sb + "SSR"] = true;
    }
  }
}

//allow Zweitwohnung for Expert and given "Selbstbeteiligungen"
function allowZweitwohnung(availabilities) {
  for (const sb of allSbs) {
    availabilities["EXP" + sb + "zus. HWRS"] = true;
    availabilities["YOLIG" + sb + "zus. HWRS"] = true;
  }
}

function allowCyber(availabilities) {
  availabilities["EXP" + "SB150" + "Cyber"] = true;
  availabilities["PRE" + "SB150" + "Cyber"] = true;
  availabilities["YOLIG" + "SB150" + "Cyber"] = true;
}

function allowVermRS(availabilities) {
  for (let productLine of ["EXP", "PRE", "YOLIG"]) {
    for (let sb of ["SB0", "SB150", "SB300"]) {
      availabilities[productLine + sb + "VermRS"] = true;
    }
  }
}

//allow SuS
function allowSus(availabilities) {
  availabilities["EXP" + "SB300" + "S&S PBVW+SSR"] = true;
}

//allow Standard for only Privat selected for given "Selbstbeteiligungen"
function allowSchubladeP(availabilities, sbs) {
  for (let sb of sbs) {
    availabilities["STD" + sb + "P"] = "schublade";
  }
  return availabilities;
}

//allow SB0 for Standard for given products
function allowSchubladeSB0(availabilities, products) {
  for (let product of products) {
    availabilities["STD" + "SB0" + product] = "schublade";
    availabilities["EXP" + "SB0" + product] = "schublade";
    if (!productsVerkehr.includes(product)) {
      availabilities["PRE" + "SB0" + product] = "schublade";
    }
  }
  return availabilities;
}

